import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_71c919e6 from 'nuxt_plugin_plugin_71c919e6' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_rollbarclient_2f11b9da from 'nuxt_plugin_rollbarclient_2f11b9da' // Source: ./rollbar-client.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_8d86d4b8 from 'nuxt_plugin_cookieuniversalnuxt_8d86d4b8' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtmq_6347e004 from 'nuxt_plugin_nuxtmq_6347e004' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_pluginutils_77e237bf from 'nuxt_plugin_pluginutils_77e237bf' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_83985d6c from 'nuxt_plugin_pluginrouting_83985d6c' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_12f5ae65 from 'nuxt_plugin_pluginmain_12f5ae65' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuescrollto_52e0248d from 'nuxt_plugin_vuescrollto_52e0248d' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_axios_55866dfc from 'nuxt_plugin_axios_55866dfc' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_webfontloader_0b67f7fc from 'nuxt_plugin_webfontloader_0b67f7fc' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_deviceplugin_ca836cf2 from 'nuxt_plugin_deviceplugin_ca836cf2' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_4080fb3c from 'nuxt_plugin_pluginclient_4080fb3c' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_4578f3ea from 'nuxt_plugin_pluginserver_4578f3ea' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_iconplugin_e56aaec2 from 'nuxt_plugin_iconplugin_e56aaec2' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_cookies_d3269bca from 'nuxt_plugin_cookies_d3269bca' // Source: ../plugins/cookies (mode: 'all')
import nuxt_plugin_gtm_caeab2a8 from 'nuxt_plugin_gtm_caeab2a8' // Source: ../plugins/gtm (mode: 'client')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_filters_2abc1387 from 'nuxt_plugin_filters_2abc1387' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_googlemaps_15b47544 from 'nuxt_plugin_googlemaps_15b47544' // Source: ../plugins/googlemaps (mode: 'client')
import nuxt_plugin_clickoutside_49fe0f11 from 'nuxt_plugin_clickoutside_49fe0f11' // Source: ../plugins/clickoutside (mode: 'client')
import nuxt_plugin_scrolllock_2c6901b7 from 'nuxt_plugin_scrolllock_2c6901b7' // Source: ../plugins/scroll-lock (mode: 'client')
import nuxt_plugin_modal_22cddd39 from 'nuxt_plugin_modal_22cddd39' // Source: ../plugins/modal (mode: 'client')
import nuxt_plugin_notifications_3edb2b74 from 'nuxt_plugin_notifications_3edb2b74' // Source: ../plugins/notifications (mode: 'client')
import nuxt_plugin_swupdate_c11fce44 from 'nuxt_plugin_swupdate_c11fce44' // Source: ../plugins/sw-update (mode: 'client')
import nuxt_plugin_auth_92710cc8 from 'nuxt_plugin_auth_92710cc8' // Source: ../plugins/auth (mode: 'client')
import nuxt_plugin_facebook_75641cba from 'nuxt_plugin_facebook_75641cba' // Source: ../plugins/facebook (mode: 'client')
import nuxt_plugin_tiktok_428e9fee from 'nuxt_plugin_tiktok_428e9fee' // Source: ../plugins/tiktok (mode: 'client')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_switch_419e2628 from 'nuxt_plugin_switch_419e2628' // Source: ../plugins/switch (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - ticketshop.ee","meta":[{"charset":"utf-8"},{"name":"version","content":"1.4.141"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"name":"format-detection","content":"telephone=no"},{"property":"fb:app_id","content":"824047961096401"},{"name":"color-scheme","content":"light only"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.jsdelivr.net","crossorigin":true}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_71c919e6 === 'function') {
    await nuxt_plugin_plugin_71c919e6(app.context, inject)
  }

  if (typeof nuxt_plugin_rollbarclient_2f11b9da === 'function') {
    await nuxt_plugin_rollbarclient_2f11b9da(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_8d86d4b8 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_8d86d4b8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_6347e004 === 'function') {
    await nuxt_plugin_nuxtmq_6347e004(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_77e237bf === 'function') {
    await nuxt_plugin_pluginutils_77e237bf(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_83985d6c === 'function') {
    await nuxt_plugin_pluginrouting_83985d6c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_12f5ae65 === 'function') {
    await nuxt_plugin_pluginmain_12f5ae65(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_52e0248d === 'function') {
    await nuxt_plugin_vuescrollto_52e0248d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_55866dfc === 'function') {
    await nuxt_plugin_axios_55866dfc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_0b67f7fc === 'function') {
    await nuxt_plugin_webfontloader_0b67f7fc(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_ca836cf2 === 'function') {
    await nuxt_plugin_deviceplugin_ca836cf2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_4080fb3c === 'function') {
    await nuxt_plugin_pluginclient_4080fb3c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_4578f3ea === 'function') {
    await nuxt_plugin_pluginserver_4578f3ea(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_e56aaec2 === 'function') {
    await nuxt_plugin_iconplugin_e56aaec2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookies_d3269bca === 'function') {
    await nuxt_plugin_cookies_d3269bca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_caeab2a8 === 'function') {
    await nuxt_plugin_gtm_caeab2a8(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2abc1387 === 'function') {
    await nuxt_plugin_filters_2abc1387(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_15b47544 === 'function') {
    await nuxt_plugin_googlemaps_15b47544(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_49fe0f11 === 'function') {
    await nuxt_plugin_clickoutside_49fe0f11(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrolllock_2c6901b7 === 'function') {
    await nuxt_plugin_scrolllock_2c6901b7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_22cddd39 === 'function') {
    await nuxt_plugin_modal_22cddd39(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notifications_3edb2b74 === 'function') {
    await nuxt_plugin_notifications_3edb2b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swupdate_c11fce44 === 'function') {
    await nuxt_plugin_swupdate_c11fce44(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_92710cc8 === 'function') {
    await nuxt_plugin_auth_92710cc8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebook_75641cba === 'function') {
    await nuxt_plugin_facebook_75641cba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tiktok_428e9fee === 'function') {
    await nuxt_plugin_tiktok_428e9fee(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_switch_419e2628 === 'function') {
    await nuxt_plugin_switch_419e2628(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
